
if(!customElements.get('filter-drawer')){
    class FilterDrawer extends HTMLElement {
        constructor(){
            super();

            // close drawer
            this.addEventListener('click', this.onDrawerClick.bind(this));
            this.querySelectorAll('[data-close]').forEach(item => {
                item.addEventListener('click', this.close.bind(this));
                item.addEventListener('keydown', e => {
                    if(e.key === 'Enter' || e.key === ' '){
                        e.preventDefault();
                        this.close();
                    }
                });
            });

            this.addEventListener('keyup', e => {
                if(e.code && e.code.toUpperCase() === 'ESCAPE'){
                    this.close();
                }
            });
        }

        connectedCallback(){
            this.filterUpdateUnsubscriber = PubSub.subscribe(PubSub.events.filterDrawerUpdate, this.handleFilterDrawerReload.bind(this));
            this.handleFilterUpdate();
        }

        disconnectedCallback(){
            if(this.filterUpdateUnsubscriber && typeof this.filterUpdateUnsubscriber === 'function'){
                this.filterUpdateUnsubscriber();
            }
        }

        handleFilterDrawerReload(){
            this.handleFilterUpdate();
        }

        handleFilterUpdate(){
            this.checkboxes = this.querySelectorAll('input[type="checkbox"]');
            this.checkboxes.forEach(item => {
                const label = this.querySelector(`[for="${item.id}"]`);
                item.addEventListener("change", this.onClickFilterValue.bind(this));
                label?.addEventListener("keydown", e => {
                    if(e.key == 'Enter' || e.key == ' '){
                        e.preventDefault();
                        item.checked = !item.checked;
                        item.dispatchEvent(new Event("change", { bubbles: true }));
                    }
                });
            });

            this.priceInputs = this.querySelectorAll('input[type="number"]');
            this.priceInputs.forEach(item => {
                item.addEventListener("change", this.onClickFilterValue.bind(this));
            });

            this.buttonClear = this.querySelector(".button-clear");
            if(this.buttonClear){
                this.buttonClear.addEventListener("click", this.clearAll.bind(this));
                this.buttonClear.addEventListener("keydown", e => {
                    if(e.key === 'Enter'){
                        this.clearAll();
                    }
                });
            }

            this.buttonResetPrice = this.querySelector('.button-reset');
            if(this.buttonResetPrice){
                this.buttonResetPrice.addEventListener("click", this.clearPriceInputs.bind(this));
                this.buttonResetPrice.addEventListener("keydown", e => {
                    if(e.key === 'Enter'){
                        this.clearPriceInputs();
                    }
                });
            }
        }

        onClickFilterValue(e){
            PubSub.publish(PubSub.events.onSubmitFacets, { callback: this.callback.bind(this) });
        }

        callback(){
            this.handleFilterUpdate();
        }

        open(triggerElement){
            this.previouslyFocusedElement = triggerElement || document.activeElement;

            this.removeAttribute('inert');

            requestAnimationFrame(() => {
                this.setAttribute('data-hidden', 'false');
            });

            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';

            FocusTrap.activate(this);

            setTimeout(() => {
                this.addFocus();
            }, 700);
        }

        addFocus(){
            const tabableElems = this.querySelectorAll('[tabindex="0"]');
            if(tabableElems){
                setTimeout(() => {
                    tabableElems[0].focus();
                }, 100);
            }
        }

        close(){
            FocusTrap.deactivate(this);

            this.setAttribute('data-hidden', 'true');
            this.setAttribute('inert', '');

            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';

            if(this.previouslyFocusedElement){
                this.previouslyFocusedElement.focus();
            }
        }

        onDrawerClick(e){
            const isDrawerClicked = e.target === e.currentTarget;
            if(isDrawerClicked){
                this.close();
            }
        }

        clearAll(){
            this.checkboxes.forEach(item => {
                item.checked = false;
            });

            this.priceInputs.forEach(item => {
                item.value = '';
            });

            PubSub.publish(PubSub.events.onSubmitFacets, { callback: this.callback.bind(this) });
        }

        clearPriceInputs(){
            this.priceInputs.forEach(item => {
                item.value = '';
            }); 

            PubSub.publish(PubSub.events.onSubmitFacets, { callback: this.callback.bind(this) });
        }
    }

    customElements.define('filter-drawer', FilterDrawer);
}
